import React, { useState, useEffect } from 'react';
import './AddToSelfCart.css';

const AddToSelfCart = ({ medicine, onClose, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);
  const [totalPrice, setTotalPrice] = useState(medicine.price); // Initial total price

  // Update total price whenever quantity changes
  useEffect(() => {
    setTotalPrice(medicine.price * quantity);
  }, [quantity, medicine.price]);

  const handleAddToCart = () => {
    if (quantity > 0) {
      onAddToCart({ ...medicine, quantity, totalPrice });
      onClose();
    }
  };

  return (
    <div className="add-to-self-cart-overlay" onClick={onClose}>
      <div className="add-to-self-cart-modal" onClick={(e) => e.stopPropagation()}>
        <button className="add-to-self-cart-modal-close-btn" onClick={onClose}>x</button>

        <h2 className="add-to-self-cart-modal-title">{medicine.name} by {medicine.company}</h2>
        <p className="add-to-self-cart-modal-text"><strong>Expiry Date:</strong> {medicine.expiryDate}</p>
        <p className="add-to-self-cart-modal-text"><strong>Strength:</strong> {medicine.strength}</p>
        <p className="add-to-self-cart-modal-text"><strong>Price per unit:</strong> ₹{medicine.price}</p>

        <div className="add-to-self-cart-quantity-selector">
          <label htmlFor="quantity" className="quantity-label">Quantity: </label>
          <input 
            type="number" 
            id="quantity" 
            className="quantity-input-selfcart" 
            value={quantity} 
            min="1" 
            onChange={(e) => setQuantity(parseInt(e.target.value))}
          />
        </div>

        <p className="add-to-self-cart-total-price">
          <strong>Total Price: </strong> ₹{totalPrice}
        </p>

        <button onClick={handleAddToCart} className="add-to--self-cart-modal-btn">Add to Cart</button>
      </div>
    </div>
  );
};

export default AddToSelfCart;
